import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  // mode: 'history',  //去掉url中的#
  mode: "hash",
  routes: [
    {
      path: "/home",
      name: "home",
      component: resolve => require(["@/views/Home/Home"], resolve)
    },
    // {
    //   path: "/covid19",
    //   component: resolve => require(["@/views/covid/covid"], resolve),
    //   name: "COVID-19"
    // },
    {
      path: "/products",
      name: "products",
      component: resolve => require(["@/views/products/products"], resolve),
      children: [
        {
          path: "",

          component: resolve => require(["@/views/products"], resolve),
          name: "PRODUCTS & SERVICES"
        },
        {
          path: "order",

          component: resolve =>
            require(["@/views/products/productsDetails/order"], resolve),
          name: "HOW TO ORDER"
        },
        {
          path: "Brochures",

          component: resolve =>
            require(["@/views/products/productsDetails/Brochures"], resolve),
          name: "PRODUCTS BROCHURES"
        },
        {
          path: "ngs",
          component: resolve =>
            require(["@/views/products/productsDetails/ngs"], resolve),
          name: "AILISNGS<sup>®</sup>"
        },
        {
          path: "wes",

          component: resolve =>
            require(["@/views/products/productsDetails/wes"], resolve),
          name: "EXOME SEQUENCING (WES)"
        },
        {
          path: "gene",

          component: resolve =>
            require(["@/views/products/productsDetails/gene"], resolve),
          name: "GENE PANELS"
        },
        {
          path: "lowWgs",

          component: resolve =>
            require(["@/views/products/productsDetails/lowWgs"], resolve),
          name: "LOW-PASS WGS"
        },
        // {
        //   path: "cma",

        //   component: resolve =>
        //     require(["@/views/products/productsDetails/cma"], resolve),
        //   name: "MICROARRAY (CMA)"
        // },
        {
          path: "mito",

          component: resolve =>
            require(["@/views/products/productsDetails/mito"], resolve),
          name: "MITOCHONDRIAL GENOME SEQUENCING"
        },
        {
          path: "reanalysis",

          component: resolve =>
            require(["@/views/products/productsDetails/reanalysis"], resolve),
          name: "NGS DATA REANALYSIS"
        },
        // {
        //   path: "sanger",
        //   component: resolve =>
        //     require(["@/views/products/productsDetails/sanger"], resolve),
        //   name: "SANGER SEQUENCING"
        // },
        {
          path: "wgs",
          component: resolve =>
            require(["@/views/products/productsDetails/wgs"], resolve),
          name: "WGS"
        },
        {
          path: "f8",
          component: resolve =>
            require(["@/views/products/productsDetails/f8"], resolve),
          name: "F8 Inversions"
        },
        {
          path: "Fragile",
          component: resolve =>
            require(["@/views/products/productsDetails/Fragile"], resolve),
          name: "Fragile X Repeat Expansion"
        }
      ]
    },
    {
      path: "/about",
      name: "about",
      component: resolve => require(["@/views/about/about"], resolve),
      children: [
        {
          path: "",
          component: resolve => require(["@/views/about"], resolve),
          name: "ABOUT AILIFE"
        },
        {
          path: "people",

          component: resolve =>
            require(["@/views/about/aboutDetails/people"], resolve),
          name: "OUR PEOPLE"
        },
        {
          path: "mission",

          component: resolve =>
            require(["@/views/about/aboutDetails/mission"], resolve),
          name: "OUR MISSION"
        },
        //  {
        //   path: 'licenses',
        //   component: resolve => (require(["@/views/about/aboutDetails/licenses"], resolve)), name: 'OUR LICENSES'
        // },
        {
          path: "licenses",
          component: resolve =>
            require(["@/views/about/aboutDetails/licenses"], resolve),
          name: "OUR LICENSES"
        },
        {
          path: "publications",

          component: resolve =>
            require(["@/views/about/aboutDetails/publications"], resolve),
          name: "OUR PUBLICATIONS"
        },
        {
          path: "cantact",
          component: resolve =>
            require(["@/views/about/aboutDetails/cantact"], resolve),
          name: "CONTACT US"
        },
        {
          path: "privacy",
          component: resolve =>
            require(["@/views/about/aboutDetails/policy"], resolve),
          name: "PRIVACY"
        }
      ]
    },
    {
      path: "/media",
      name: "media",
      component: resolve => require(["@/views/media/media"], resolve),
      children: [
        {
          path: "",
          component: resolve => require(["@/views/media"], resolve),
          name: "NEWS & Blogs"
        },
        {
          path: "news1",
          component: resolve =>
            require(["@/views/media/mediaDetails/news1"], resolve),
          name: "ASHG 2019 MEETING, HOUSTON"
        },
        {
          path: "news3",
          component: resolve =>
            require(["@/views/media/mediaDetails/news3"], resolve),
          name: "AiLife Diagnostics Achieves HITRUST Certification"
        },
        {
          path: "news2",

          component: resolve =>
            require(["@/views/media/mediaDetails/news2"], resolve),
          name:
            "AILIFE DIAGNOSTICS AND BGI AMERICAS PARTNER TO PROVIDE CLINICAL WGS SOLUTION"
        },
        {
          path: "blog1",

          component: resolve => require(["@/views/media/blogs/news1"], resolve),
          name: "Mappability in Calling CNVs in Exomes"
        },
        {
          path: "blog2",

          component: resolve => require(["@/views/media/blogs/news2"], resolve),
          name: "Public Perceptions of Genomic Data Sharing"
        },
        {
          path: "blog3",

          component: resolve => require(["@/views/media/blogs/news3"], resolve),
          name: "Types of laboratory testing for COVID-19"
        }
      ]
    },
    {
      path: "/tools",
      component: resolve => require(["@/views/tools/tools"], resolve),
      name: "Tools",
      children: [
        {
          path: "",
          component: resolve => require(["@/views/tools"], resolve),
          name: "TOOLS"
        },
        {
          path: "AutoHPO",
          component: resolve =>
            require(["@/views/tools/toolsDetails/hpo"], resolve),
          name: "AutoHPO"
        },
        {
          path: "DiseaseRK",
          component: resolve =>
            require(["@/views/tools/toolsDetails/hpoGene"], resolve),
          name: "DiseaseRK"
        }
      ]
    },
    // {
    //   path: '/tools/hpoGene',
    //   component: resolve => require(['@/views/tools/hpoGene'], resolve),
    //   name: 'tools/hpoGene'
    // },

    {
      path: '/join',
      component: resolve => require(['@/views/join/join'], resolve),
      children: [{
        path: '',
        component: resolve => require(['@/views/join/joinList'], resolve), name: 'WE ARE HIRING'
      }],

    },
    { path: "*", redirect: "/home" }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js